import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, TemplateRef, ViewChild } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';
import { FormControlTemplatesService } from 'src/app/templates/form-control-templates.service';

@Component({
  selector: 'fpx-selectable-dropdown',
  templateUrl: './fpx-selectable-dropdown.component.html',
  styleUrls: ['./fpx-selectable-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxSelectableDropdownComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FpxSelectableDropdownComponent extends BaseFpxControlComponent {
  @Input() disableOptionCentering: boolean = true;

  selectedData: any;
  template: TemplateRef<any>;

  constructor(
    controlContainer: ControlContainer, 
    changeDetectorRef: ChangeDetectorRef,
    private _fromControlTemplateService:FormControlTemplatesService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    super(controlContainer, changeDetectorRef);
  }

  protected doPreInit(): void {}

  protected doPostInit(): void {}

  onSelectionChange($event, data) {
    if ($event.isUserInput) {
      this.selectedData = data;
    }
  }

  setInitialSelectedData(list: any) {
    let _selectData;
    if (this.formControl.value) {
      _selectData = list.find((option) => { return option.id === this.formControl.value });
    } else {
      _selectData = null;
    }
    setTimeout(()=>{
      this.selectedData = _selectData;
      this._changeDetectorRef.markForCheck();
    });
  }

  getTemplate(ngTemplateName:string): TemplateRef<any> {
    let tmplt = this._fromControlTemplateService.getTemplate(ngTemplateName, 'dropdown');
    return tmplt;
  }

}
